import { render, staticRenderFns } from "./SelectCustomTargetingModal.vue?vue&type=template&id=3529d383&scoped=true"
import script from "./SelectCustomTargetingModal.vue?vue&type=script&lang=js"
export * from "./SelectCustomTargetingModal.vue?vue&type=script&lang=js"
import style0 from "./SelectCustomTargetingModal.vue?vue&type=style&index=0&id=3529d383&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3529d383",
  null
  
)

export default component.exports